import React from 'react';
import ContentLoader from 'react-content-loader';

const ProjectLoader = () => (
  <ContentLoader
    height={660}
    width={1200}
    speed={3}
    primaryColor={"#ccc"}
    secondaryColor={"#DCDCDC"}
  >
    <rect id="Rectangle" x="0" y="95" width="380" height="250" rx="3"></rect>
    <rect id="Rectangle" x="405" y="95" width="390" height="250" rx="3"></rect>
    <rect id="Rectangle" x="405" y="370" width="795" height="250" rx="3"></rect>
    <rect id="Rectangle" x="820" y="95" width="380" height="250" rx="3"></rect>
    <rect id="Rectangle" x="959" y="30" width="241" height="25" rx="3"></rect>
    <rect id="Rectangle" x="0" y="30" width="653" height="25" rx="3"></rect>
    <rect id="Rectangle" x="0" y="370" width="380" height="250" rx="3"></rect>
  </ContentLoader>
);

export default ProjectLoader;



// WEBPACK FOOTER //
// ./src/components/common/loaders/project-loader.js